'use strict'

let win = $(window),
touch = false,
docHeight,
winWidth,
winHeight,
scrollpane,
fadeCoords = [],
fadeHeight = [],
_qg = {};


_qg.ua = (function(){
	
	let _ua = navigator.userAgent.toLowerCase();
	let _o = {
		ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
		ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
		ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
		IE9: navigator.appVersion.toLowerCase().indexOf("msie 9.") != -1,
		IE10 : navigator.userAgent.match(/Trident\/[6]/i),
		IE11: navigator.userAgent.match(/Trident\/7\./),
		IE:document.uniqueID,
		Firefox:window.sidebar,
		Opera:window.opera,
		chrome: _ua.indexOf('chrome') > -1,
		//Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
		mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
		iphone:/iphone|ipod/i.test(_ua),
		android:/android/.test(_ua),
		ipad:/ipad/.test(_ua),
		tablet:undefined,
		smartphone:undefined,
		touch: window.ontouchstart === null
	}
	_o.tablet = _o.ipad;
	if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}				
	_o.smartphone = _o.iphone || _o.android ? true : false;
	
	let v = [];
	if (/iP(hone|od|ad)/.test(navigator.platform)) {v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);}
	let vAry = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	_o.iosV = vAry[0] ? vAry[0] : '';
	
	return _o;
})();


// var len = images.length;
// var n = Math.floor( Math.random() * len );
// var ary = [images[n]];


	function id(v){ return document.getElementById(v); }
	function loadbar() {
		var ovrl = id("overlay"),
				prog = id("progress"),
				stat = id("progstat"),
				img = document.images,
				c = 0,
				tot = img.length;
		if(tot == 0) return doneLoading();

		function imgLoaded(){
			c += 1;
			var perc = ((100/tot*c) << 0) +"vh";
			prog.style.height = perc;
			//stat.innerHTML = "Loading "+ perc;
			if(c===tot) return doneLoading();

		}
		function doneLoading(){
			
			setTimeout(function(){ 
				$('#overlay img').css({opacity: 0});
			}, 600);			
			setTimeout(function(){ 
				$('#overlay').addClass('done');
			}, 1200);
			setTimeout(function(){ 
				$('#overlay').remove();

			if(location.hash){
				let e;
				alert('test')
				pageScrollTo(location.hash, e);
			}

			}, 2000);	
			
					
		}
		for(var i=0; i<tot; i++) {
			var tImg     = new Image();
			tImg.onload  = imgLoaded;
			tImg.onerror = imgLoaded;
			tImg.src     = img[i].src;
		}    
	}
	




$(document).ready(()=>{

	$('.hamburger-button').on('click', (e)=>{
		$(e.currentTarget).toggleClass('opened');
		$('#g-nav').slideToggle();
	});

	$(document).on('click touchend', (e)=>{
		setTimeout(()=>{
			if(!$(e.target).closest('#header').length){
				if($('.hamburger-button').hasClass('opened')){
					$('.hamburger-button').removeClass('opened');
					$('#g-nav').slideToggle();
				}
			}
		}, 100);
	});

	$('.anchor, #g-nav a').on('click', (e)=>{
		let tar = $(e.currentTarget).attr('href');
		pageScrollTo(tar, e);
	});			

	let cookie = new makeCookie();
	
	let is_passed = cookie.readCookie('pabst_beer');


	if(is_passed != 1){
		
		let html = '<div id="modal-base-layer"></div>'+
		'<div id="modal-contents-layer">'+
			'<div id="appended-contents">'+
			'</div>'+
		'</div>';

		$('body').append(html);

		let modal = new modalWindow('#modal-base-layer', '#modal-contents-layer', '#appended-contents');		
		let cont = $('.age-verification').clone();
		modal.setContents(cont, {align: 'center', marginTop: 0, speed: 600, bgOpacity: 1, style: {backgroundColor: '#012169'}, closeOnClick: false});	

		modal.toggle({
			beforeOpen:()=>{
				$('#appended-contents').css({opacity: 0});			
				$('#appended-contents .button').on('click',(e)=>{
					e.preventDefault();
					let answer = $(e.currentTarget).attr('href');
					if(answer.indexOf('yes') > -1){
						$('#appended-contents .error').text('');
						modal.toggle();
						cookie.createCookie('pabst_beer', 1, 90);
						if($('.home-page').length){
							$('#overlay').addClass('visible');
							loadbar();
						}
					} else {
						$('#appended-contents .error').text('20歳未満の方はコンテンツをご覧いただけません。');
					}
				});
			},
			onOpen: ()=>{
				$('#appended-contents').css({opacity: 1});
			}
		});	

	} else {
		if($('.home-page').length){
			$('#overlay').addClass('visible');
			loadbar();
		}
	}

	let st;
	$(window).on('scroll', (e)=>{
		st = $(window).scrollTop();
		if(st > 200){
			$('.go-top').addClass('fadeIn');
			$('.go-top').removeClass('fadeOut');
		} else {
			$('.go-top').removeClass('fadeIn');
			$('.go-top').addClass('fadeOut');
		}
		if(st > 50){
			$('.hero-section .arrow').removeClass('fadeIn');
			$('.hero-section .arrow').addClass('fadeOut');
		} else {
			$('.hero-section .arrow').addClass('fadeIn');
			$('.hero-section .arrow').removeClass('fadeOut');
		}		
	});

});

$.event.add(window, "load", function(){	

  if($('.swiper-container .swiper-slide').length > 1){
    let swiper = new Swiper(".swiper-container",{
			spaceBetween: 0,
			loop: true,
			speed: 800,
			autoplay: {
				delay: 4000,
			},			
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			}
    });
  }

});


const pageScrollTo = (tar, e)=>{

	let base = location.protocol + '//' + location.hostname;

	if(location.pathname != '/' && !location.pathname)
	base +=  '/' + location.pathname;

	if(!location.pathname || location.pathname == '/'){
		base += '/';
	}

	tar = tar.replace(base, '');

	let str = tar.slice(0, 1);

	if(str == '#'){

		if(e)
		e.preventDefault();

		tar = tar.replace('#', '');

		if($('[data-id="' + tar + '"]').length){
			let pos = tar == 'header' ? 0 : $('[data-id="'+tar+'"]').offset().top - 80;
			$('html,body').stop().animate({ scrollTop: pos }, 1000, 'easeOutExpo');
		}

	}

}


class makeCookie {

	constructor() {

	}

	createCookie(name, value, days) {
		let expires;

		if (days) {
				let date = new Date();
				date.setTime(date.getTime()+(days*24*60*60*1000));
				expires = "; expires=" + date.toGMTString();
		} else {
				expires = "";
		}
		document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
	}

	readCookie(name) {
		let nameEQ = encodeURIComponent(name) + "=";
		let ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
		}
		return null;
	}

	eraseCookie(name) {
		this.createCookie(name, "", -24);
	}

}


class modalWindow {

	constructor(base, contents, wrap) {
		this.isOpen = false;
		this.baseLayer = $(base);
		this.contentsLayer = $(contents);
		this.contentsWrap = $(wrap);
		this.contents;
		this.optionsDefault = {url: null, fullscreen: false, align: 'top', marginTop: 0, speed: 1000, bgOpacity: 1, style:{backgroundColor: '#000'}, closeOnClick: true}
		this.options;
		this.onUpdateCallback;
	}

	setContents (data, param){
		let obj = param;
		this.options = $.extend({}, this.optionsDefault, obj);
		this.contents = data;
	}

	update (data, func){
		let _self = this;
		let callback = func ? func : ()=>{};
		_self.contents = data;
		$(_self.contentsWrap, _self.contentsLayer).fadeOut(400, 'easeOutCubic');
		
		setTimeout(()=>{
			$(_self.contentsWrap, _self.contentsLayer).html('');
			$(_self.contentsWrap, _self.contentsLayer).append(_self.contents);
			_self.resize();
			callback();
			$(_self.contentsWrap, _self.contentsLayer).fadeIn(400, 'easeOutCubic');
			
			if(_self.onUpdateCallback)
			_self.onUpdateCallback();
			
		}, 400);
	}

	reset() {
		
	}

	toggle(obj) {
		$('body').addClass('no-scroll');	
		let _self = this;
		let w = win.width();
		let h = win.height();
		let callbacks = {
			beforeOpen : ()=>{},
			beforeClose : ()=>{},
			onOpen : ()=>{},
			onClose : ()=>{},
		}
		
		callbacks = $.extend({}, callbacks, obj);
		
		let callbackbeforeOpen = callbacks.beforeOpen;
		let callbackbeforeClose = callbacks.beforeClose;
		let callbackOnOpen = callbacks.onOpen;
		let callbackOnClose = callbacks.onClose;
		
		if(!_self.isOpen){
					
			$('.btn-modal-close', self.contentsLayer).on('click', function(e){
				e.preventDefault();
				_self.toggle(callbackOnOpen);
			});
			
			win.on('resize.modalWindow load.modalWindow', function(){
				_self.resize();
			});
		
			$(_self.contentsWrap, _self.contentsLayer).append(_self.contents);
			
			
			
			_self.contentsLayer.animate({scrollTop: 0});
			
			if(_self.options.fullscreen){
				_self.baseLayer.css({width: w, height: h, opacity: 0, backgroundColor: _self.options.style.baseColor, top: h}).show();
				_self.baseLayer.stop().animate({
					top: 0
				}, _self.options.speed, 'easeOutCubic');
				_self.contentsLayer.css({top: h}).show();
				callbackbeforeOpen();
				_self.contentsLayer.stop().animate({
					top: 0
				}, _self.options.speed, 'easeOutCubic', ()=>{
					callbackOnOpen();	
				});
			} else {
				_self.baseLayer.attr('style', '');
				_self.baseLayer.css({width: w, height: h, top: 0, left: 0, opacity: 0}).addClass('modal-style-01').css(_self.options.style).show();
				_self.baseLayer.stop().animate({
					opacity: _self.options.bgOpacity
				}, _self.options.speed, 'easeOutCubic');

				_self.contentsLayer.css({opacity: 0, top: 0, left: 0}).show();
				callbackbeforeOpen();
				_self.contentsLayer.stop().animate({
					opacity: 1
				}, _self.options.speed, 'easeOutCubic', ()=>{
					callbackOnOpen();
					// if(_qg.ua.mobile){
					// 	$('> *', _self.contentsWrap).wrap('<div id="modal-iscroll-container"><div id="modal-iscroll-container-inner"></div></div>');
					// 	$('#modal-iscroll-container').css({position: 'fixed', top: 0, bottom: 0, overflow: 'hidden', width: '100%'});
					// 	$('#modal-iscroll-container').imagesLoaded(function(){
					// 		let myScroll = new IScroll('#modal-iscroll-container', { mouseWheel: true, click: true, zoom: true });
					// 		$(document).on('touchmove.modal', function (e) { e.preventDefault(); });
					// 	});
					// }		
				});
		
		
				if(_self.closeOnClick){
					_self.contentsLayer.on('click', function(e){		
						if($(e.target).attr('id') == 'modal-contents-layer' || $(e.target).attr('id') == 'modal-contents-wrap' || $(e.target).attr('id') == 'appended-contents')
						_self.toggle(callbackOnOpen);
					});
				}

				$('.btn-modal-close').on('click tap', function(e){
					e.preventDefault();
					_self.toggle(callbackOnOpen);
				});
				
			}
					
			_self.isOpen = true;
			_self.resize();
			
		} else {
		
			callbackbeforeClose();
		
			if(_self.options.fullscreen){
				
				_self.baseLayer.stop().animate({
					top: win.height()
				}, _self.options.speed, 'easeOutCubic', ()=>{});

				_self.contentsLayer.off('scroll').animate({scrollTop: 0}, 0);
				_self.contentsLayer.stop().animate({
					top: win.height()
				}, _self.options.speed, 'easeOutCubic', ()=>{

					callbackOnClose();
					$(_self.contentsWrap, _self.contentsLayer).html('');
					_self.reset();
					_self.isOpen = false;
					_self.isOpen = null;
					_self.options =  null;
					_self.baseLayer.hide();
					_self.contentsLayer.hide();
					_self.contents = null;		
				});
				
			} else {

				_self.baseLayer.stop().fadeOut(_self.options.speed, 'easeOutCubic', ()=>{});
				
				_self.contentsLayer.stop().fadeOut(_self.options.speed, 'easeOutCubic', ()=>{
			
					_self.baseLayer.removeClass('modal-style-01');
					$(_self.contentsWrap, _self.contentsLayer).html('');
					_self.reset();
					_self.isOpen = false;
					_self.isOpen = null;
					_self.options =  null;
					_self.baseLayer.hide();
					_self.contentsLayer.hide();
					_self.contents = null;	
				});			
				
				$('.btn-modal-close').off('click');
			
			}
			
			_self.onUpdateCallback = null;
			
			setTimeout(()=>{
				if(_qg.ua.mobile){
					$(document).off('touchmove.modal');
				}	
				callbackOnClose();
			}, _self.options.speed);		
			
			$('body').removeClass('no-scroll');
			
			win.off('resize.modalWindow load.modalWindow');	
			_self.isOpen = true;
		}
	}

	resize(){

		let _self = this;
		
		let w = win.width();
		let h = win.height();
			
		if(_self.isOpen){
			let diff = _qg.ua.iphone ? 100 : 0;
			_self.baseLayer.css({ width: w, height: h + diff});
			_self.contentsLayer.css({width: w, height: h + diff});	
			
			if(_self.options.align == 'center'){

				setTimeout(()=>{
					let contH = _self.contents.outerHeight();
					let contY = (h - contH) / 2;
					let contW = _self.contents.outerWidth();
					let contX = (w - contW) / 2;	
					_self.contentsWrap.css({marginTop: Math.max(contY, 0)});
				}, 10);

			} else {
				_self.contentsWrap.css({marginTop: _self.options.marginTop});
			}
			

			if(_self.contents.height() < w){
				_self.contentsLayer.css({overflowY: 'auto'});
			} else {
				_self.contentsLayer.css({overflowY: 'scroll'});
			}
		}
	}


}
